import { BaseModel, DateModel, InterventionModel } from "~/model"
import { DevisResource } from "~/api"

export class DevisModel extends BaseModel<DevisResource> {
    static primaryKey = "IDDEVIS"

    get interventions() {
        return this.INTERVENTION?.length
            ? this.INTERVENTION.map((i) => new InterventionModel(i))
            : []
    }

    get isCommande() {
        return this.DEVIS_SIGNE
    }

    get isPublicDevis() {
        return (
            !this.DEVIS_SIGNE &&
            this.DATE_TRANSMISSION !== "0000-00-00T00:00:00.000" &&
            this.REFUSE !== 1
        )
    }

    get dateCreation() {
        if (
            !this.DATE_CREATION ||
            this.DATE_CREATION === "0000-00-00T00:00:00.000"
        )
            return "/"
        return DateModel.formatDate(this.DATE_CREATION)
    }

    get dateTransmission() {
        if (
            !this.DATE_TRANSMISSION ||
            this.DATE_TRANSMISSION === "0000-00-00T00:00:00.000"
        )
            return "/"
        return DateModel.formatDate(this.DATE_TRANSMISSION)
    }

    get dateSignature() {
        if (
            !this.DATE_SIGNATURE ||
            this.DATE_SIGNATURE === "0000-00-00T00:00:00.000"
        )
            return "/"
        return DateModel.formatDate(this.DATE_SIGNATURE)
    }

    get dateConsultation() {
        if (
            !this.DATE_CONSULTATION ||
            this.DATE_CONSULTATION === "0000-00-00T00:00:00.000"
        )
            return "/"
        return DateModel.formatDateTime(this.DATE_CONSULTATION)
    }

    get prixTTC() {
        return (this.PRIX_TTC || 0).toLocaleString("fr-FR", {
            style: "currency",
            currency: "EUR",
        })
    }

    get numeroDate() {
        return `${this.NUMERO_DEVIS} du ${this.DATE_EDITION}`
    }
}

export interface DevisModel extends DevisResource {}
